// Merged alpha-2 map: mobile's 46 entries + PostTripFlow gap countries + full-name aliases
const COUNTRY_CODES = {
  // Mobile's original entries (exact key strings the mobile app uses)
  'Egypt': 'EG', 'Italy': 'IT', 'Japan': 'JP', 'France': 'FR',
  'Spain': 'ES', 'USA': 'US', 'UK': 'GB', 'Greece': 'GR',
  'Thailand': 'TH', 'Mexico': 'MX', 'Brazil': 'BR', 'Australia': 'AU',
  'India': 'IN', 'Morocco': 'MA', 'Portugal': 'PT', 'Germany': 'DE',
  'Netherlands': 'NL', 'Turkey': 'TR', 'UAE': 'AE', 'Singapore': 'SG',
  'Indonesia': 'ID', 'Peru': 'PE', 'Colombia': 'CO', 'Argentina': 'AR',
  'South Africa': 'ZA', 'Kenya': 'KE', 'Canada': 'CA', 'China': 'CN',
  'South Korea': 'KR', 'Vietnam': 'VN', 'Cambodia': 'KH', 'Iceland': 'IS',
  'Norway': 'NO', 'Sweden': 'SE', 'Denmark': 'DK', 'Switzerland': 'CH',
  'Austria': 'AT', 'Belgium': 'BE', 'Croatia': 'HR', 'Czech Republic': 'CZ',
  'Hungary': 'HU', 'Poland': 'PL', 'Romania': 'RO', 'New Zealand': 'NZ',
  // Full-name aliases for mobile's short forms
  'United Arab Emirates': 'AE', 'United Kingdom': 'GB', 'United States': 'US',
  // Countries from PostTripFlow not covered by mobile's map
  'Afghanistan': 'AF', 'Albania': 'AL', 'Algeria': 'DZ', 'Angola': 'AO',
  'Bangladesh': 'BD', 'Bolivia': 'BO', 'Bulgaria': 'BG', 'Cameroon': 'CM',
  'Chile': 'CL', 'Costa Rica': 'CR', 'Cuba': 'CU', 'Ecuador': 'EC',
  'Ethiopia': 'ET', 'Finland': 'FI', 'Ghana': 'GH', 'Guatemala': 'GT',
  'Iran': 'IR', 'Iraq': 'IQ', 'Ireland': 'IE', 'Israel': 'IL',
  'Jamaica': 'JM', 'Jordan': 'JO', 'Kuwait': 'KW', 'Laos': 'LA',
  'Lebanon': 'LB', 'Malaysia': 'MY', 'Nepal': 'NP', 'Nigeria': 'NG',
  'Pakistan': 'PK', 'Panama': 'PA', 'Philippines': 'PH', 'Qatar': 'QA',
  'Russia': 'RU', 'Saudi Arabia': 'SA', 'Senegal': 'SN', 'Slovakia': 'SK',
  'Sri Lanka': 'LK', 'Taiwan': 'TW', 'Uganda': 'UG', 'Ukraine': 'UA',
  'Uruguay': 'UY', 'Venezuela': 'VE', 'Yemen': 'YE', 'Zimbabwe': 'ZW',
};

export function getCountryCode(name) {
  if (!name) return '';
  const trimmed = name.trim();
  if (COUNTRY_CODES[trimmed]) return COUNTRY_CODES[trimmed];
  const titleCased = trimmed.split(/\s+/).map(w => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase()).join(' ');
  if (COUNTRY_CODES[titleCased]) return COUNTRY_CODES[titleCased];
  return COUNTRY_CODES[trimmed.toUpperCase()] || '';
}

export function getFlagEmoji(code) {
  if (!code || code.length !== 2) return '';
  return code.toUpperCase().split('').map(c => String.fromCodePoint(127397 + c.charCodeAt(0))).join('');
}

const TIMEZONEDB_KEY = process.env.REACT_APP_TIMEZONEDB_KEY;

export async function detectCountryFromCity(city) {
  if (!city || !city.trim() || !TIMEZONEDB_KEY) return null;
  try {
    const res = await fetch(
      `https://api.timezonedb.com/v2.1/get-time-zone?key=${TIMEZONEDB_KEY}&format=json&by=city&city=${encodeURIComponent(city.trim())}`
    );
    const data = await res.json();
    if (data.status === 'OK' && data.countryCode) return data.countryCode;
    return null;
  } catch (err) {
    console.error('Country detection error:', err);
    return null;
  }
}
